module.exports = __webpack_public_path__ + "static/31-f880871916dcbbab9ade6fd6a471a099.png";